import IconButton from "@/components/IconButton";
import MaterialIcon from "@/components/MaterialIcon";
import SkeletonTextLine from "@/components/SkeletonTextLine";
import { formatMedicationTimingLines, Medication } from "@/model/Medication";
import { ComponentPropsWithoutRef } from "react";
import InfoBox from "./InfoBox";

type MedicationBoxProps = {
  medications: Medication[];
  isLoading: boolean;
  onEditSelected: () => void;
} & ComponentPropsWithoutRef<"div">;

const MedicationBox = ({
  medications,
  isLoading,
  onEditSelected,
  className,
  ...otherProps
}: MedicationBoxProps) => (
  <InfoBox className={className} {...otherProps}>
    <div className="mb-2 flex items-center justify-between gap-2">
      <InfoBox.Header>Medication</InfoBox.Header>
      <IconButton variant="neutral" onClick={onEditSelected} disabled={isLoading}>
        <MaterialIcon iconName="edit" style={{ fontSize: "20px" }} />
      </IconButton>
    </div>
    {isLoading ? (
      <div className="flex flex-col gap-3">
        {[0, 1, 2, 3].map((i) => (
          <SkeletonTextLine key={i} className="h-4 w-56" />
        ))}
      </div>
    ) : medications.length === 0 ? (
      <p className="text-primary/60">No medication</p>
    ) : (
      <div className="flex flex-col divide-y divide-gray-200">
        {medications.map((medication, index) => {
          const timingLines = formatMedicationTimingLines(medication.timing);
          return (
            <div
              key={`${medication.name}-${index}`}
              className="flex items-center justify-between gap-4 py-2 first:pt-0"
            >
              <span className="font-semibold text-primary/90">{medication.name}</span>
              <span className="flex flex-col text-right text-primary/60">
                {timingLines.length === 0 ? (
                  <span>-</span>
                ) : (
                  timingLines.map((line, i) => <span key={i}>{line}</span>)
                )}
              </span>
            </div>
          );
        })}
      </div>
    )}
  </InfoBox>
);

export default MedicationBox;
